import React from 'react';
import { Page, Text, View, Document, Link, Image } from '@react-pdf/renderer';
import {
  PageHeader,
  PageFooter,
  styles,
  PageHeaderLogo,
  CorrectiveActions,
} from '../constants';
import { Notes } from '../constants';
import { VehicleCard } from '../vehicle';
import { Category } from './../assessment_components/assessment_category';
import { Signatures } from './../assessment_components/assessment_signatures';
import { textStyles } from '../styles';
import { ExecutiveSummaryDocument } from './executive_summary';
import { useTranslation } from 'react-i18next';
import { keys } from '../../translator/translation_keys';
import { imageExtensions } from '../../files';

export const AuditDocument = ({
  inspection,
  correctiveActions,
  notes,
  props = {},
}) => {
  const { t } = useTranslation();
  const company = inspection?.creator?.company;
  const referenceFiles = [
    ...(inspection.template?.images || []),
    ...(inspection.attachments?.filter(
      (a) => a.fileType !== 'AUDIO' && a.extension !== 'SIGNATURE',
    ) || []),
  ];
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <PageHeaderLogo company={company} workspace={null} />
        <PageHeader
          company={company}
          data={inspection}
          title={inspection.template.title}
          workspace={null}
          type="Audit"
          revision={inspection?.template?.revisionNumber}
        />
        <View>
          <Text style={styles.titleHeader}>{`${inspection.template.title} - ${
            inspection.auditType || ''
          } Audit`}</Text>
          <Text style={styles.headerText}>
            {inspection.template.description}
          </Text>
        </View>
        {!!inspection.vehicle ? (
          <VehicleCard vehicle={inspection?.vehicle} />
        ) : null}
        {!!props.summary && (
          <ExecutiveSummaryDocument
            inspection={inspection}
            company={company}
            correctiveActions={correctiveActions}
            showDetails={false}
            showHeader={false}
          />
        )}
        {props.checklist && (
          <View break={!!props.summary}>
            <Text
              style={styles.titleHeader}
            >{`${inspection.template.title} Audit Checklist`}</Text>
            <View style={styles.categoryContainer}>
              {inspection.template.categories.map((category, index) => (
                <Category
                  key={`${category.id}-${index}`}
                  category={category.title}
                  categoryId={category.id}
                  isBundle={category.isBundle}
                  questions={category.questions}
                  answers={inspection.items}
                  isAudit={true}
                  correctiveActions={correctiveActions}
                  showComments={!!props.comments}
                />
              ))}
            </View>
          </View>
        )}
        {!!props.actions && !!correctiveActions?.length && (
          <View break={!!props.checklist} style={styles.categoryContainer}>
            <Text style={textStyles.categoryHeader}>
              Corrective Preventative Action Summary
            </Text>
            {correctiveActions?.map((c) => (
              <CorrectiveActions correctiveAction={c || []} key={c.id} />
            ))}
          </View>
        )}
        {!!props.notes && (
          <View>
            <Notes notes={notes} style={styles.categoryContainer} />
            <Text style={styles.text}>{inspection.notes}</Text>
          </View>
        )}
        {!!props.signatures && !!inspection.attachments?.length && (
          <Signatures
            signatures={
              inspection.attachments?.filter(
                (a) => a.extension === 'SIGNATURE',
              ) || []
            }
          />
        )}
        {referenceFiles?.length && props?.files && (
          <View style={styles.categoryContainer}>
            <Text style={styles.categoryHeader}>
              {t(keys.common.REFERENCE_FILES)}
            </Text>
            <View style={styles.templateImageContainer}>
              {referenceFiles?.map((file, index) => {
                const { imageUrl, url, extension, name, id } = file || {};
                const src = imageUrl || url;
                const ext = extension || src?.split('.')?.pop();
                return imageExtensions.includes(ext) ? (
                  <Image
                    style={styles.templateImage}
                    src={src}
                    key={`${id}-${index}`}
                  />
                ) : (
                  <View key={id}>
                    <Text style={styles.text}>{`File Type: ${extension}`}</Text>
                    <Link style={styles.linkLeft} src={src}>
                      {name}
                    </Link>
                  </View>
                );
              })}
            </View>
          </View>
        )}
        <PageFooter />
      </Page>
    </Document>
  );
};
